import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import { isAIModuleAllowedHandler, notifyUser } from "../../services/helpers";

import SubNavigation from "../../components/Header/SubNavigation";
import ClientConfigurationModal from "../../components/Modals/ClientConfigurationModal";
import ClientDocumentsConfigModal from "../../components/Modals/ClientDocumentsConfigModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import ClientConfigurationTable from "../../components/Tables/ClientConfigurationTable";
import UserContext from "../../store/user-context";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";

const ClientConfiguration = () => {
  const [clients, setClients] = useState(null);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editableClient, setEditableClient] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    getClientConfigurations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getClientConfigurations = () => {
    setIsLoading(true);
    sendApiRequest(
      "ClientConfiguration/GetClientConfigurations",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setClients(response.data.clientConfigurations);
          setIsLoading(false);
        }
      }
    });
  };

  const modalOpenHandler = (client) => {
    setModalOpen(true);
    setEditableClient(client);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
    getClientConfigurations();
    isAIModuleAllowedHandler(
      userContext.selectedClientFiscalCode,
      signIn,
      signOut,
      navigate,
      userContext,
      setError
    );
  };

  const documentsModalOpenHandler = () => {
    modalCloseHandler();
    setDocumentsModalOpen(true);
  };

  const documentsModalCloseHandler = () => {
    setDocumentsModalOpen(false);
  };

  const confirmModalOpenHandler = (client) => {
    setEditableClient(client);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent =
        client.clientCodeName;
    }, 200);
    setConfirmModalOpen(true);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  return (
    <Fragment>
      <SubNavigation
        display={false}
        openModalHandler={modalOpenHandler}
        page="clientConfiguration"
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <ClientConfigurationTable
            items={clients}
            columns={[
              {
                name: "Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCodeName",
              },
              {
                name: "Codice Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCode",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Stato",
                type: "string",
                sortable: false,
                value: "status",
              },
              {
                name: "AWS Bucket",
                type: "string",
                sortable: false,
                value: "",
              },
              {
                name: "Azioni",
                type: "",
                sortable: false,
                value: "",
              },
            ]}
            openModalHandler={modalOpenHandler}
            confirmModalOpenHandler={confirmModalOpenHandler}
            getClientConfigurations={getClientConfigurations}
          />
        )}
      </Section>
      <ClientConfigurationModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        selectedClient={editableClient}
        documentsModalOpenHandler={documentsModalOpenHandler}
        setClients={setClients}
      />
      <ClientDocumentsConfigModal
        modalOpen={documentsModalOpen}
        modalCloseHandler={documentsModalCloseHandler}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        notifyUser={notifyUser}
        method={"deleteClientConfigurationHandler"}
        text={"Stai per eliminare l'tipologia servizio configurazione"}
        clientId={editableClient.clientId}
        setClients={setClients}
      />
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
      <Footer />
    </Fragment>
  );
};

export default ClientConfiguration;
